import React from 'react';
import { Typography, } from '@mui/material'
import Grid from '@mui/material/Grid';

function RequiredText() {
    return (
      <Grid container direction="row">
        <Typography sx={{ color: '#9C2F36', mr: '2px' }}>*</Typography>
        <Typography sx={{ fontSize: '0.75rem', fontWeight: '400' }}>required fields</Typography>
      </Grid>
    )
}

export default RequiredText;